import { getShortcodeHTMLTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";

const editCustomHTMLAdditionConfig = (editor, event) => {
  const shortcodeWrapper = event.composedPath()[1];
  const customHtmlWrapper = shortcodeWrapper.querySelectorAll('[data-tiny-mce-component="custom-partner"]')[0];
  const customHtmlContent = customHtmlWrapper.innerHTML;
  editor.windowManager.open({
    title: "Video Embed / Custom HTML",
    body: {
      type: "panel",
      items: [
        {
          type: "textarea", // component type
          name: "custom",
          label: "Custom HTML code",
          disabled: false,
          maximized: false,
        },
      ],
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    initialData: {
      custom: customHtmlContent,
    },
    onSubmit: api => {
      customHtmlWrapper.innerHTML = api.getData().custom;
      api.close();
    },
  });
};
const customHTMLAdditionConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Video Embed / Custom HTML",
    body: {
      type: "panel",
      items: [
        {
          type: "textarea",
          name: "customHtml",
          label: "Custom HTML code",
          disabled: false,
          maximized: false,
        },
      ],
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();
      const templateToAdd = getShortcodeHTMLTemplate({
        html: data.customHtml,
      });
      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  });
};
export { customHTMLAdditionConfig, editCustomHTMLAdditionConfig };
